import React from 'react';
import Icon from '../../../../../../muiComponents/Icon';
import useTranslate from '../../../../../../customHooks/useTranslate';
import { useZitoneoSettingsChecks } from '../../../../contexts/ZitoneoContentContext';

const PublishedCheck = () => {
    const translate = useTranslate();
    const { published } = useZitoneoSettingsChecks();

    const title = published ? 'published__complete' : 'published__incomplete';
    const subtitle = !published ? 'published__complete_subtitle' : '';

    const icon = published ? 'Check' : 'PublicOff';

    return (
        <li className='sidebar__quality_signal__item'>
            <div className='flex-column gap-8'>
                <div className='quality_signal__item__title'>
                    <Icon
                        iconName={icon}
                        className={`quality_signal__item__icon --${
                            published ? 'success' : 'warning'
                        }`}
                    />
                    <p>{translate(title)}</p>
                </div>
                {subtitle && <p>{translate(subtitle)}</p>}
            </div>
        </li>
    );
};

export default PublishedCheck;
